import React, { useMemo } from 'react';
import { Body } from '../Constants/Fonts';
import { NovaProvider } from './NovaContext';
import Launcher from './components/Launcher';
import Panel from './components/Panel';
import { createNovaApi } from './novaApi';
import './nova.css';

export default function NovaWidget({ api, status = 'online' }) {
    const resolvedApi = useMemo(() => api || createNovaApi(), [api]);

    return (
        <NovaProvider api={resolvedApi} status={status}>
            <Body as="div" className="nova_root">
                <Launcher />
                <Panel />
            </Body>
        </NovaProvider>
    );
}
